export const photos = [
  {
    id: 1,
    src: '/images/photo1.jpg',
    alt: 'Notre moment ensemble',
    caption: 'Un souvenir précieux'
  },
  {
    id: 2,
    src: '/images/photo2.jpg',
    alt: 'Moments de bonheur',
    caption: 'Ensemble, toujours'
  },
  {
    id: 3,
    src: '/images/photo3.jpg',
    alt: 'Notre aventure',
    caption: 'Chaque instant compte'
  },
  {
    id: 4,
    src: '/images/photo4.jpg',
    alt: 'Sourires partagés',
    caption: 'Notre complicité'
  },
  {
    id: 5,
    src: '/images/photo5.jpg',
    alt: 'Notre histoire',
    caption: 'Des moments magiques'
  },
  {
    id: 6,
    src: '/images/photo6.jpg',
    alt: 'Notre amour',
    caption: 'Pour toujours'
  }
]
